import { render, staticRenderFns } from "./TagsDropdown.vue?vue&type=template&id=25a286f6&scoped=true&"
import script from "./TagsDropdown.vue?vue&type=script&lang=js&"
export * from "./TagsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TagsDropdown.vue?vue&type=style&index=0&id=25a286f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a286f6",
  null
  
)

export default component.exports